var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Pagination',{attrs:{"table-collection":_vm.logCollection,"detailed":true,"sorting-field":"timestamp","range-field":"timestamp"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"label":_vm.$t('severity')}},[_c('b-tooltip',{class:props.row.type === 'log'
            ? 'is-info'
            : props.row.type === 'warning'
            ? 'is-warning'
            : props.row.type === 'error'
            ? 'is-danger'
            : '',attrs:{"position":"is-left","label":props.row.type === 'log'
            ? _vm.$t('logLevel1')
            : props.row.type === 'warning'
            ? _vm.$t('logLevel2')
            : props.row.type === 'error'
            ? _vm.$t('logLevel3')
            : ''}},[_c('b-icon',{attrs:{"icon":props.row.type === 'log'
              ? 'flag'
              : props.row.type === 'warning'
              ? 'alert'
              : props.row.type === 'error'
              ? 'alert-octagon'
              : '',"type":props.row.type === 'log'
              ? 'is-info'
              : props.row.type === 'warning'
              ? 'is-warning'
              : props.row.type === 'error'
              ? 'is-danger'
              : ''}})],1)],1),_c('b-table-column',{attrs:{"label":_vm.$t('cloudFunction')}},[_vm._v(" "+_vm._s(props.row.cloudFunction)+" ")]),_c('b-table-column',{attrs:{"label":_vm.$t('msg')}},[_vm._v(" "+_vm._s(props.row.msg)+" ")]),_c('b-table-column',{attrs:{"label":_vm.$t('error')}},[_vm._v(" "+_vm._s(props.row.error)+" ")]),_c('b-table-column',{attrs:{"label":_vm.$t('actions'),"centered":""}},[_c('b-button',{attrs:{"type":"is-small is-danger ml-2","icon-right":"delete"},on:{"click":function($event){return _vm.deleteError(props.row.id)}}})],1),_c('b-table-column',{attrs:{"label":_vm.$t('timestamp'),"centered":""}},[_c('span',{staticClass:"tag is-primary"},[_vm._v(" "+_vm._s(props.row.timestamp.toDate().toLocaleTimeString() + ", " + props.row.timestamp.toDate().toLocaleDateString())+" ")])])]}},{key:"detail",fn:function(props){return [_c('ul',_vm._l((props.row.metadata),function(value,key){return _c('li',{key:key},[_c('b',[_vm._v(_vm._s(key))]),_vm._v(": "+_vm._s(value)+" ")])}),0)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }